import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { OpenBidsApiParameter } from "@steiner/App/Services/OpenBidsService";

type HandlerType = ApiHandler<any & UpdateSearchFieldsType>;

export const DispatchUpdateSearchFieldsParameter: HandlerType = props => {
    props.dispatch({
        type: "xOpenBids/UpdateSearchParams",
        parameter: props.parameter,
    } as any);
};

export const chain = [DispatchUpdateSearchFieldsParameter];

const updateOpenBidsSearchFields = createHandlerChainRunner(chain, "UpdateOpenBidsSearchFields");
export default updateOpenBidsSearchFields;
